import axios from 'axios'
import { api } from '@/services/config'
import { mixin } from '@/mixins/helper'
import router from '../../router'
import store from '@/store'

const approvalSheet = {
  namespaced: true,
  state: () => ({
    page: 1,
    perPage: 10,
    totalItems: 0,
    totalPages: 0,
    list: null,
    detail: null,
    status: null,
    type: null,
    request_id: null,
    choosedFilter: 0,
    search: null,
    company_code: null,
    order_by: 'id',
    order_short: 'desc',
    reviewState: 0,
  }),
  mutations: {
    SET_APPROVAL_LIST(state, payload) {
      state.list = payload.value.items
      state.page = mixin.methods.$get(
        payload.value,
        'paginationInformation.page',
        1
      )
      state.perPage = mixin.methods.$get(
        payload.value,
        'paginationInformation.perPage',
        10
      )
      state.totalItems = mixin.methods.$get(
        payload.value,
        'paginationInformation.totalItems',
        0
      )
      state.totalPages = mixin.methods.$get(
        payload.value,
        'paginationInformation.totalPages',
        0
      )
    },
    SET_PAGINATION(state, payload) {
      state[payload.name] = payload.value
    },
    SET_DATA(state, payload) {
      state[payload.name] = payload.value
    },
    SET_ORDER_SHORT(state) {
      if (state.order_short == 'asc') {
        state.order_short = 'desc'
      } else {
        state.order_short = 'asc'
      }
    },
  },
  actions: {
    getApproval: async ({ commit, state, rootState }, payload) => {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      let query = ''
      if (state.choosedFilter) query += `&status=${state.choosedFilter}`
      if (state.search) query += `&search=${state.search}`

      if (state.order_by) {
        query += `&order_by=${state.order_by}&order_short=${state.order_short}`
      }

      if (state.company_code) {
        query += `&company_code=${state.company_code}`
      }

      const url = `${api}/api/v1/request/approval?page=${
        payload && payload.change ? 1 : state.page
      }&limit=${state.perPage}&user_id=${rootState.userid}${query}`

      try {
        const { data } = await axios({
          method: 'GET',
          url,
        })

        await commit('SET_APPROVAL_LIST', { name: 'list', value: data.data })
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async setPagination({ commit, dispatch }, payload) {
      await commit('SET_PAGINATION', payload)
      await dispatch('getApproval')
    },
    async approveVendor({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/approve/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: 'done',
            user_id: rootState.userid,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          if (
            store.state.modalReqApp.modalViewExtend ||
            store.state.modalReqApp.modalViewBlock ||
            store.state.modalReqApp.modalViewUnblock
          ) {
            await commit('modalReqApp/CLOSE_ALL', null, { root: true })
            await dispatch('getApproval')
          } else if (store.state.modalStore.showModalLevel1) {
            await commit('modalStore/SET_MODAL_LEVEL1', false, { root: true })
            await dispatch('getApproval')
          } else {
            await router.push({ path: '/approval' })
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await router.push({ path: '/approval' })
      }
    },

    async approveHead({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/approvehead/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: 'done',
            user_id: rootState.userid,
          },
        })

        if (data && data.status == 'success') {
          if (data.data && data.data.message && data.data.message.length > 0) {
            let message = ''
            let filterMessage = await data.data.message.filter(
              i => i.indexOf('[E]') != -1
            )

            if (filterMessage.length > 0) {
              for (let i in filterMessage) {
                if (i == 0) {
                  message += filterMessage[i]
                } else {
                  message += `, ${filterMessage[i]}`
                }
              }

              commit('SET_NOTIF', message, { root: true })
            } else {
              commit('SET_NOTIF', data.message, { root: true })
            }
          } else {
            commit('SET_NOTIF', data.message, { root: true })
          }

          await commit('SET_GLOBAL_LOADING', false, { root: true })

          if (
            store.state.modalReqApp.modalViewExtend ||
            store.state.modalReqApp.modalViewBlock ||
            store.state.modalReqApp.modalViewUnblock
          ) {
            await commit('modalReqApp/CLOSE_ALL', null, { root: true })
            await dispatch('getApproval')
          } else if (store.state.modalStore.showModalLevel1) {
            await commit('modalStore/SET_MODAL_LEVEL1', false, { root: true })
            await dispatch('getApproval')
          } else {
            await router.push({ path: '/approval' })
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await router.push({ path: '/approval' })
      }
    },

    async rejectVendor({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/reject/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: payload && payload.note,
            user_id: rootState.userid,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          if (
            store.state.modalReqApp.modalViewExtend ||
            store.state.modalReqApp.modalViewBlock ||
            store.state.modalReqApp.modalViewUnblock
          ) {
            await commit('modalReqApp/CLOSE_ALL', null, { root: true })
            await dispatch('getApproval')
          } else if (store.state.modalStore.showModalLevel1) {
            await commit('modalStore/SET_MODAL_LEVEL1', false, { root: true })
            await dispatch('getApproval')
          } else {
            await router.push({ path: '/approval' })
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await router.push({ path: '/approval' })
      }
    },
    async postpone({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/postpone/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: 'done',
            user_id: rootState.userid,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          if (
            store.state.modalReqApp.modalViewExtend ||
            store.state.modalReqApp.modalViewBlock ||
            store.state.modalReqApp.modalViewUnblock
          ) {
            await commit('modalReqApp/CLOSE_ALL', null, { root: true })
            await dispatch('getApproval')
          } else if (store.state.modalStore.showModalLevel1) {
            await commit('modalStore/SET_MODAL_LEVEL1', false, { root: true })
            await dispatch('getApproval')
          } else {
            await router.push({ path: '/approval' })
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await router.push({ path: '/approval' })
      }
    },
    async reviewVendor({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/review/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: payload && payload.note,
            user_id: rootState.userid,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          if (
            store.state.modalReqApp.modalViewExtend ||
            store.state.modalReqApp.modalViewBlock ||
            store.state.modalReqApp.modalViewUnblock
          ) {
            await commit('modalReqApp/CLOSE_ALL', null, { root: true })
            await dispatch('getApproval')
          } else if (store.state.modalStore.showModalLevel1) {
            await commit('modalStore/SET_MODAL_LEVEL1', false, { root: true })
            await dispatch('getApproval')
          } else {
            await router.push({ path: '/approval' })
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await router.push({ path: '/approval' })
      }
    },
    async reviewHead({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/reviewhead/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: payload && payload.note,
            user_id: rootState.userid,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          if (
            store.state.modalReqApp.modalViewExtend ||
            store.state.modalReqApp.modalViewBlock ||
            store.state.modalReqApp.modalViewUnblock
          ) {
            await commit('modalReqApp/CLOSE_ALL', null, { root: true })
            await dispatch('getApproval')
          } else if (store.state.modalStore.showModalLevel1) {
            await commit('modalStore/SET_MODAL_LEVEL1', false, { root: true })
            await dispatch('getApproval')
          } else {
            await router.push({ path: '/approval' })
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await router.push({ path: '/approval' })
      }
    },
    async reSendEmail({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/resend-email/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            email: payload && payload.note,
            user_id: payload && payload.user_id,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          commit(
            'modalReqApp/SET_VALUE',
            {
              name: 'modalReview',
              value: false,
            },
            { root: true }
          )
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async reSendEmailK3l({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/resend-email-k3l/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            email: payload && payload.note,
            user_id: payload && payload.user_id,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          commit(
            'modalReqApp/SET_VALUE',
            {
              name: 'modalResendEmailK3l',
              value: false,
            },
            { root: true }
          )
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async reSendEmailKplh({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/resend-email-kplh/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            email: payload && payload.note,
            user_id: payload && payload.user_id,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          commit(
            'modalReqApp/SET_VALUE',
            {
              name: 'modalResendEmailK3l',
              value: false,
            },
            { root: true }
          )
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
      }
    },
    async rejectK3l({ commit, dispatch, rootState }, payload) {
      commit('SET_GLOBAL_LOADING', true, { root: true })
      const url = `${api}/api/v1/request/reject-k3l/${payload.id}`
      try {
        const { data } = await axios({
          method: 'POST',
          url,
          data: {
            note: payload && payload.note,
            user_id: rootState.userid,
          },
        })

        if (data && data.status == 'success') {
          await commit('SET_NOTIF', data.message, { root: true })
          await commit('SET_GLOBAL_LOADING', false, { root: true })

          if (
            store.state.modalReqApp.modalViewExtend ||
            store.state.modalReqApp.modalViewBlock ||
            store.state.modalReqApp.modalViewUnblock
          ) {
            await commit('modalReqApp/CLOSE_ALL', null, { root: true })
            await dispatch('getApproval')
          } else if (store.state.modalStore.showModalLevel1) {
            await commit('modalStore/SET_MODAL_LEVEL1', false, { root: true })
            await dispatch('getApproval')
          } else {
            await router.push({ path: '/approval' })
          }
        }
      } catch (error) {
        await commit(
          'SET_NOTIF',
          mixin.methods.$get(error, 'response.data.message', 'Error'),
          { root: true }
        )
        await commit('SET_GLOBAL_LOADING', false, { root: true })
        await router.push({ path: '/approval' })
      }
    },
  },
}

export default approvalSheet
